<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <!--<Avatar :src="userAvator"/>-->
      {{username}}
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="editPwd">修改密码</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Modal
      v-model="d_modal_pwd"
      title="修改密码"
      footer-hide>
      <Form ref="formCustom" :model="d_formCustom" :rule="ruleCustom" :label-width="80">
        <FormItem label="原密码" prop="OldPass">
          <Input type="password" v-model="d_formCustom.OldPass"></Input>
        </FormItem>
        <FormItem label="新密码" prop="NewPass">
          <Input type="password" v-model="d_formCustom.NewPass"></Input>
        </FormItem>
        <FormItem label="确认新密码" prop="NewPassConfirm">
          <Input type="password" v-model="d_formCustom.NewPassConfirm"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formCustom')" style="margin-right: 10px;">提交</Button>
          <Button @click="handleCancel()" >取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import './user.less'
import apiLogin from '@/api/login.js';
export default {
  name: 'User',
  props: {
//    userAvator: {
//      type: String,
//      default: ''
//    }
  },
  data(){
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.d_formCustom.NewPassConfirm !== '') {
          // 对第二个密码框单独验证
          this.$refs.formCustom.validateField('NewPassConfirm');
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'));
      } else if (value !== this.d_formCustom.NewPass) {
        callback(new Error('The two input passwords do not match!'));
      } else {
        callback();
      }
    };
    return{
      d_modal_pwd:false,
      d_formCustom:{
        OldPass:'',
        NewPass:'',
        NewPassConfirm:''
      },
      ruleCustom: {
        OldPass: [
          { required: true, message: '原密码不能为空', trigger: 'blur' }
        ],
        NewPass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        NewPassConfirm: [
          { validator: validatePassCheck, trigger: 'blur' }
        ]
      },
      username: ''
    }
  },
  methods: {
    handleClick (name) { //退出登录
      switch (name) {
        case 'logout':
          this.to_loginOut();
          break
        case 'editPwd':
          this.to_editPwd();
          break;
      }
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.edit_password();
        } else {
          this.$Message.error('验证失败!');
        }
      })
    },
    to_loginOut(){
      apiLogin.logout().then((_data) => {
        sessionStorage.setItem('token','');
        sessionStorage.setItem('menu','');
        sessionStorage.setItem('name','');
        sessionStorage.setItem('role','');
        this.$router.push({
          name: 'login'
        })
        if(_data.data.ExeSuccess && _data.data.LoginSuccess){

        }else {
          this.$Message.error(_data.data.Msg);
        }
      })
    },
    to_editPwd(){ this.d_modal_pwd=true; },
    handleCancel(){this.d_modal_pwd=false; },
    edit_password(){
      apiLogin.editPassword.post(this.d_formCustom).then((_data) => {
        if(_data.data.ExeSuccess && _data.data.LoginSuccess){
          this.$Message.success('密码修改成功');
          this.d_modal_pwd=false;
        }else {
          this.$Message.error(_data.data.Msg);
        }
      })
    },

  },
  created(){
    this.username = sessionStorage.getItem('name');
  }
}
</script>
